import { Form } from "antd";
import { PositiveRankv2Item } from "generated/api";
import { useTranslation } from "react-i18next";

import DefaultForm from "../DefaultForm";
import { SelectionSiteItemSelect, YesNo } from "../inputs";

type PositiveRankv2Props = {
  forumId: number;
  selectionSiteId: number;
  item: PositiveRankv2Item;
  onChange: (item: PositiveRankv2Item) => void;
};

const PositiveRankv2 = ({ forumId, selectionSiteId, item, onChange }: PositiveRankv2Props) => {
  const { t } = useTranslation();

  const handleChange = (values: Partial<PositiveRankv2Item> & { TO_REMOVE: unknown }) => {
    const newValues = {
      ...item,
      ...values,
    };
    // It's a temp fix for the Ant Form to render the content inside the Form.Item
    // when no `name` is passed to it.
    delete newValues.TO_REMOVE;
    return onChange(newValues);
  };

  return (
    <DefaultForm
      itemId={item.id}
      initialValues={item}
      onChange={handleChange}
      options={() => (
        <>
          <Form.Item name="associatedSelectionStep" label={t("Associated selection step")}>
            <SelectionSiteItemSelect
              forumId={forumId}
              selectionSiteId={selectionSiteId}
              types={["PositiveSelectionV2"]}
            />
          </Form.Item>

          <Form.Item name="showReasonForMeetingDropdown" label={t("Show reason for meeting dropdown")}>
            <YesNo />
          </Form.Item>

          <Form.Item name="showReasonForMeetingFreeText" label={t("Show reason for meeting free text")}>
            <YesNo />
          </Form.Item>

          <Form.Item name="resolveLabels" label={t("Display localised labels")}>
            <YesNo />
          </Form.Item>

          <Form.Item name="showOtherReasonForMeeting" label={t("Show other reason for meeting (if any)")}>
            <YesNo />
          </Form.Item>

          <Form.Item name="showProfileDetails" label={t("Show profile details")}>
            <YesNo />
          </Form.Item>
        </>
      )}
    />
  );
};

export default PositiveRankv2;
